import React, { Component } from 'react';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Navigation from "context/nav";
import AccountTypes from "context/accountTypes";

import Profile from "./profile";
import ApiKeys from "components/profile/apiKeys";
import Accounts from "components/profile/accounts";
import Credentials from "components/profile/credentials";
import Limits from "components/profile/limits";
import PreferencesEditor from "components/profile/preferences";

export default class UserSettings extends Component {
  render() {
    if ( !this.props.user ) {
      return (<></>);
    }

    const sectionId = this.props.match.params.sectionId || "profile";

    // An account has no alias or email and cannot own accounts or organizations, so its Limits view
    // (what its new organizations would start with) has no reader. Every guard below asks whether this
    // profile is human, never what kind of account it is.
    const isHuman = AccountTypes.isHuman(this.props.user);
    const canReadLimits = isHuman && this.props.app.api.canReadUserLimits(this.props.user);

    return (
      <>
        <Container className="blob-header-row content-row">
          <Row>
            <Col sm={3}>
              <Card>
                <ListGroup variant="flush" className="blob-settings-navigation-list">
                  {"profile" === sectionId
                    ? <ListGroup.Item active>Profile</ListGroup.Item>
                    : <Link to={Navigation.userSettingsProfilePath(this.props.userId)}>
                        <ListGroup.Item>Profile</ListGroup.Item>
                      </Link>
                  }
                  {isHuman && ("accounts" === sectionId
                    ? <ListGroup.Item active>{AccountTypes.sectionLabel()}</ListGroup.Item>
                    : <Link to={Navigation.userSettingsAccountsPath(this.props.userId)}>
                        <ListGroup.Item>{AccountTypes.sectionLabel()}</ListGroup.Item>
                      </Link>
                  )}
                  {"api-keys" === sectionId
                    ? <ListGroup.Item active>API Keys</ListGroup.Item>
                    : <Link to={Navigation.userSettingsApiKeysPath(this.props.userId)}>
                        <ListGroup.Item>API Keys</ListGroup.Item>
                      </Link>
                  }
                  {"credentials" === sectionId
                    ? <ListGroup.Item active>Credentials</ListGroup.Item>
                    : <Link to={Navigation.userSettingsCredentialsPath(this.props.userId)}>
                        <ListGroup.Item>Credentials</ListGroup.Item>
                      </Link>
                  }
                  {canReadLimits && ("limits" === sectionId
                    ? <ListGroup.Item active>Limits</ListGroup.Item>
                    : <Link to={Navigation.userSettingsLimitsPath(this.props.userId)}>
                        <ListGroup.Item>Limits</ListGroup.Item>
                      </Link>
                  )}
                  {"preferences" === sectionId
                    ? <ListGroup.Item active>Preferences</ListGroup.Item>
                    : <Link to={Navigation.userSettingsPreferencesPath(this.props.userId)}>
                        <ListGroup.Item>Preferences</ListGroup.Item>
                      </Link>
                  }
                </ListGroup>
              </Card>
            </Col>
            <Col sm={9}>
              <div className={"profile" === sectionId ? "" : "hidden"}>
                <Profile
                  history={this.props.history}
                  app={this.props.app}
                  user={this.props.user}
                  profileInterface={this.props.profileInterface}
                />
              </div>
              {isHuman &&
                <div className={"accounts" === sectionId ? "" : "hidden"}>
                  <Accounts
                    app={this.props.app}
                    target={"user"}
                    targetId={this.props.user.id}
                  />
                </div>
              }
              <div className={"api-keys" === sectionId ? "" : "hidden"}>
                <ApiKeys
                  history={this.props.history}
                  app={this.props.app}
                  target={"user"}
                  targetId={this.props.user.id}
                />
              </div>
              <div className={"credentials" === sectionId ? "" : "hidden"}>
                <Credentials
                  history={this.props.history}
                  app={this.props.app}
                  target={"user"}
                  targetId={this.props.user.id}
                />
              </div>
              {canReadLimits &&
                <div className={"limits" === sectionId ? "" : "hidden"}>
                  <Limits app={this.props.app} target={"user"} targetIds={[this.props.user.id]} />
                </div>
              }
              <div className={"preferences" === sectionId ? "" : "hidden"}>
                <PreferencesEditor
                  scope={{}}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}
